export function new_Date(){
    if(arguments.length===0){
        return new Date;
    }else if(arguments.length===1){
        if(typeof arguments[0]==="string"){
            return new Date(arguments[0].replace(/-/g,'/'));
        }else{
            return new Date(arguments[0]);
        }
    }else{
        return new Date(...arguments);
    }
}
export function Date_parse(){
    if(arguments.length===0){
        return Date.parse();
    }else if(arguments.length===1){
        if(typeof arguments[0]==="string"){
            return Date.parse(arguments[0].replace(/-/g,'/'));
        }else{
            return Date.parse(arguments[0]);
        }
    }else{
        return Date.parse(...arguments);
    }
}